import store from '../store'
import { PERMISSION_LEVELS, hasPermission } from '../constants/permissions'

function auth(to, from, next) {
	const token = localStorage.getItem('@stup:token')
	if (!token) {
		return next('login')
	}

	let userData = store.state.user.user

	if (!userData) {
		const userFromStorage = localStorage.getItem('@stup:user')
		if (userFromStorage) {
			userData = JSON.parse(userFromStorage)
		}
	}

	if (!userData) {
		return next('login')
	}

	if (!userData.permission_id) {
		console.error('permission_id não encontrado no usuário:', userData)
		return next('error')
	}

	const userPermissionId = userData.permission_id

	const requiredPermission = to.meta?.permission || PERMISSION_LEVELS.USER

	if (!hasPermission(userPermissionId, requiredPermission)) {
		return next('error')
	}

	return next()
}

export default auth
